import OrderItems from './OrderItems.vue';

if (document.getElementById('order')) {
  var order = document.getElementById('order').dataset.order;
  
  if (!order) {
    order = document.getElementById('order-items').dataset.order;
  }

  console.log(order);
  var app = new Vue({
    el: '#order-items',
    template: '<OrderItems :order="this.order" />',
    data(){
      return {
        order: JSON.parse(order)
      };
    },
    created() {
      window.vue = this;
    },
    mounted() {},
    components: {
      OrderItems
    },
  });
}